<div class="panel panel-default" style="margin-bottom:10px" *ngIf="_meta | async as m">
  <div class="panel-heading" style="cursor: pointer;" (click)="getItems()">
    <h4 class="panel-title">
      <a role="button">
        <i *ngIf="IsCollapsed && !loading && (!items || items.length !== 0)" class="pull-left fa fa-chevron-down"></i>
        <i *ngIf="items && !IsCollapsed && !loading && items.length !== 0" class="pull-left fa fa-chevron-up"></i>
        <span *ngIf="loading"><i class="pull-left fa fa-pulse fa-spinner"></i></span>
        <span *ngIf="items && items.length === 0">No </span>
        <span *ngIf="!m.verbose_name_plural">{{ m.verbose_name }}</span>
        <span *ngIf="m.verbose_name_plural">{{ m.verbose_name_plural }}</span>
        <span *ngIf="m.symbol">
          <img *ngIf="m.symbol.contentType | isImage" [src]="m.symbol.url"/>
        </span>
      </a>
      <div *ngIf="m.permissions.write" class="pull-right" style="position: sticky; right: 0;">
        <span style="cursor: pointer;"
              (click)="m.permissions.write && m.type !== undefined &&
              open(foreignKey, {}, $event)">
            Add {{ m.verbose_name }}
          <i class="fa fa-plus-circle"></i>
        </span>
      </div>
    </h4>
  </div>
  <div class="panel-body table-responsive" *ngIf="items && items.length > 0 && !loading"
       [ngbCollapse]="IsCollapsed">
    <table class="table table-striped">
      <thead>
      <tr>
        <th *ngFor="let key of m.display_fields"
            [innerHTML]="m.fields[key].label | toTrusted">
        </th>
        <th *ngIf="m.permissions.write" style="width:25px">Delete</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of items">
        <td *ngFor="let key of m.display_fields" [style]="m.permissions.write ? {'cursor': 'pointer'} : null"
            (click)="m.permissions.write && open(foreignKey, item, $event)">
          <app-display-field [type]="m.fields[key].type" [value]="item[key]"
                             [choices]="m.fields[key].choices"></app-display-field>
        </td>
        <td *ngIf="m.print !== undefined" style="cursor: pointer; vertical-align: middle;">
          <a href="/api/{{m.type}}/{{item.globalid}}/{{m.print}}/" target="_blank"
             style="text-decoration: none; color: black;">
            <i class="fa fa-print fa-lg" style="padding:0px 30%;"></i>
          </a>
        </td>
        <td *ngIf="m.permissions.write" style="cursor: pointer; vertical-align: middle;"
            (click)="delete(item, m)"><i
          class="fa-regular fa-times-circle fa-lg"
          style="padding:0px 30%;"></i></td>
      </tr>

      </tbody>
    </table>

  </div>
</div>
